(() => {
  function cartCount() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then((response) => response.json())
      .then((cart) => {
        document.querySelectorAll("[data-canopy-cart-count]").forEach((node) => {
          node.textContent = cart.item_count ? `(${cart.item_count})` : "";
        });
      })
      .catch(() => {});
  }

  async function addToCart(event) {
    event.preventDefault();
    const form = event.currentTarget;
    const button = form.querySelector("button");
    if (!button) return;
    const label = button.textContent;
    button.disabled = true;
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        body: new FormData(form),
        headers: { Accept: "application/json" },
      });
      if (!response.ok) throw new Error("Could not add to cart.");
      button.textContent = "Added";
      cartCount();
    } catch {
      button.textContent = "Try again";
    }
    window.setTimeout(() => {
      button.textContent = label;
      button.disabled = false;
    }, 1600);
  }

  function bindCart(root) {
    root.querySelectorAll("[data-canopy-cart-add]").forEach((form) => {
      if (form.dataset.bound === "true") return;
      form.dataset.bound = "true";
      form.addEventListener("submit", addToCart);
    });
  }

  function messageElement(message, pinnedMessageId) {
    const item = document.createElement("li");
    item.className = "canopy-live-chat__message";
    if (message.role === "host") item.dataset.role = "host";
    if (message.id === pinnedMessageId) item.dataset.pinned = "true";

    const heading = document.createElement("div");
    const author = document.createElement("strong");
    author.textContent =
      message.id === pinnedMessageId
        ? `Pinned · ${message.authorName}`
        : message.authorName;
    heading.append(author);

    const body = document.createElement("p");
    body.textContent = message.body;
    item.append(heading, body);
    return item;
  }

  function renderChat(chat, state) {
    const status = chat.querySelector(".canopy-live-chat__status");
    const messages = chat.querySelector(".canopy-live-chat__messages");
    if (!messages) return;
    const visible = (state.messages || []).slice(-7);
    const pinned = (state.messages || []).find(
      (message) => message.id === state.pinnedMessageId,
    );
    if (pinned && !visible.some((message) => message.id === pinned.id)) {
      visible.unshift(pinned);
    }
    messages.replaceChildren(
      ...visible.map((message) =>
        messageElement(message, state.pinnedMessageId),
      ),
    );
    messages.scrollTop = messages.scrollHeight;
    if (status) {
      status.textContent = visible.length
        ? "Conversation from this live"
        : "No chat was saved for this replay.";
    }
  }

  async function loadChat(chat) {
    const endpoint = chat.dataset.endpoint;
    const handle = chat.dataset.showHandle;
    if (!endpoint || !handle) return;
    const url = new URL(endpoint, window.location.origin);
    url.searchParams.set("show_handle", handle);
    const response = await fetch(url, {
      headers: { Accept: "application/json" },
      cache: "no-store",
    });
    if (!response.ok) return;
    renderChat(chat, await response.json());
  }

  function replayParam() {
    return new URL(window.location.href).searchParams.get("replay") || "";
  }

  function syncUrl(handle, push) {
    const url = new URL(window.location.href);
    if (handle) url.searchParams.set("replay", handle);
    else url.searchParams.delete("replay");
    const state = { canopyReplay: handle || null };
    if (push) history.pushState(state, "", url);
    else history.replaceState(state, "", url);
  }

  function fillSlot(slot, node) {
    if (!slot) return;
    slot.replaceChildren();
    if (!node) return;
    if (node.matches?.("[data-replay-rail]")) {
      slot.replaceChildren(...node.children);
      return;
    }
    slot.append(node);
  }

  function closeReplay(root, updateHistory = true) {
    const dialog = root.querySelector("[data-canopy-replay]");
    const player = root.querySelector("[data-canopy-replay-player]");
    if (player) player.src = "about:blank";
    if (dialog?.open) dialog.close();
    if (updateHistory && replayParam()) syncUrl("", false);
  }

  function openReplay(root, handle, push) {
    const dialog = root.querySelector("[data-canopy-replay]");
    const template = root.querySelector(
      `[data-canopy-replay-template="${CSS.escape(handle)}"]`,
    );
    const card = root.querySelector(`[data-canopy-replay-open][data-handle="${CSS.escape(handle)}"]`);
    if (!dialog || !template || !card?.dataset.playback) return;

    const content = template.content.cloneNode(true);
    const copy = content.querySelector("[data-replay-copy]");
    const commerce = content.querySelector("[data-replay-commerce]");
    const rail = content.querySelector("[data-replay-rail]");
    const chat = content.querySelector("[data-replay-chat]");
    const player = dialog.querySelector("[data-canopy-replay-player]");
    const title = dialog.querySelector("[data-canopy-replay-title]");
    const host = dialog.querySelector("[data-canopy-replay-host]");
    const empty = dialog.querySelector("[data-canopy-replay-empty]");

    if (title) title.textContent = copy?.dataset.title || "Replay";
    if (host) {
      host.textContent = copy?.dataset.host
        ? `Hosted by ${copy.dataset.host}`
        : "";
    }
    if (player) {
      player.title = copy?.dataset.title || "Replay";
      player.src = `https://player.mux.com/${card.dataset.playback}?autoplay=true&muted=true`;
    }

    fillSlot(dialog.querySelector("[data-canopy-replay-commerce]"), commerce);
    fillSlot(dialog.querySelector("[data-canopy-replay-rail]"), rail);
    fillSlot(dialog.querySelector("[data-canopy-replay-chat]"), chat);

    const railNode = dialog.querySelector("[data-canopy-replay-rail]");
    if (empty) empty.hidden = Boolean(railNode?.children.length);

    bindCart(dialog);
    const chatNode = dialog.querySelector("[data-canopy-replay-chat] [data-canopy-live-chat]");
    if (chatNode) loadChat(chatNode).catch(() => {});
    cartCount();

    if (!dialog.open) dialog.showModal();
    if (replayParam() !== handle) syncUrl(handle, push);
  }

  function initialize(root = document) {
    root.querySelectorAll("[data-canopy-past]").forEach((section) => {
      if (section.dataset.ready === "true") return;
      section.dataset.ready = "true";

      section.addEventListener("click", (event) => {
        const closer = event.target.closest("[data-canopy-replay-close]");
        if (closer) {
          closeReplay(section);
          return;
        }
        const opener = event.target.closest("[data-canopy-replay-open]");
        if (!opener || opener.disabled) return;
        openReplay(section, opener.dataset.handle, true);
      });

      const dialog = section.querySelector("[data-canopy-replay]");
      dialog?.addEventListener("close", () => {
        const player = section.querySelector("[data-canopy-replay-player]");
        if (player) player.src = "about:blank";
        if (replayParam()) syncUrl("", false);
      });

      const handle = replayParam();
      if (handle) openReplay(section, handle, false);
    });
  }

  window.addEventListener("popstate", () => {
    document.querySelectorAll("[data-canopy-past]").forEach((section) => {
      const handle = replayParam();
      if (handle) openReplay(section, handle, false);
      else closeReplay(section, false);
    });
  });

  initialize();
  document.addEventListener("shopify:section:load", (event) => {
    initialize(event.target);
  });
})();
